import type { ListBatchJobItemsParams } from "../../../../../lib/corpusApi";

export type DocumentIndexingRefreshTabKey = "fields_added" | "no_new_fields" | "failed";

export interface DocumentIndexingRefreshTabConfig {
  label: string;
  /** Query params sent to GET /batch-jobs/:id/items for this tab. */
  apiFilters: Pick<ListBatchJobItemsParams, "status" | "outcome">;
}

/** One tab per refresh outcome, plus the documents the run failed on. Order is display order. */
export const DOCUMENT_INDEXING_REFRESH_TABS: Record<
  DocumentIndexingRefreshTabKey,
  DocumentIndexingRefreshTabConfig
> = {
  fields_added: {
    label: "Fields added",
    apiFilters: { outcome: "fields_added" },
  },
  no_new_fields: {
    label: "No new fields",
    apiFilters: { outcome: "no_new_fields" },
  },
  failed: {
    label: "Failed",
    apiFilters: { status: "failed" },
  },
};

export const DOCUMENT_INDEXING_REFRESH_TAB_ORDER: DocumentIndexingRefreshTabKey[] = [
  "fields_added",
  "no_new_fields",
  "failed",
];
